/**
 * True once it's safe to auto-send into the thread. A remote thread imports its
 * persisted history on (re)mount; auto-sending before that settles lets the
 * message be persisted and then re-imported by the in-flight load, colliding in
 * MessageRepository ("same id already exists in the parent tree" — performOp/link).
 *
 * "Settled" requires the import cycle to have been observed this mount (isLoading
 * latched true via sawThreadLoading, now false) — NOT just "messages present",
 * since a warm remount holds the prior session's messages while a fresh import is
 * still pending: the window that crashed the t5 embed.
 */
export function isHistorySettled({
  remoteId,
  isThreadLoading,
  sawThreadLoading,
}: {
  remoteId?: string;
  isThreadLoading: boolean;
  sawThreadLoading: boolean;
}): boolean {
  if (!remoteId) return true;
  return !isThreadLoading && sawThreadLoading;
}
